<template>
    <v-app>
        <v-app-bar app color="black" dark class="pl-0">
            <img class="img-fluid logo" src="/images/e1gokart.jpg" alt="Logo">
            <v-menu
                v-model="showMenu"
                offset-y
                style="max-width: 600px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex align-center track font-weight-medium text-decoration-underline text-uppercase leagues" @click="showMenu=true">
                        <span>{{getMenuText}}</span>
                    </div>
                </template>
                <v-list>
                    <v-list-item @click="leagueFilter = null">
                        <v-list-item-title>{{$t('allCompetitions')}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="leagueFilter = 'kielecka'">
                        <v-list-item-title>{{$t('league', {league: 'Kielecka'})}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item  @click="leagueFilter = 'poznańska'">
                        <v-list-item-title>{{$t('league', {league: 'Poznańska'})}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item  @click="leagueFilter = 'slaska'">
                        <v-list-item-title>{{$t('league', {league: 'Śląska'})}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item  @click="leagueFilter = 'pomorska'">
                        <v-list-item-title>{{$t('league', {league: 'Pomorska'})}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item  @click="leagueFilter = 'pec'">
                        <v-list-item-title>{{$t('league', {league: 'Polish Endurance Cup'})}}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-toolbar-items v-if="!isMobile">
                <inertia-link href="/form">
                    <v-btn text>{{$t('reserveRace')}}</v-btn>
                </inertia-link>
                <inertia-link href="/">
                    <v-btn text>{{$t('calendar')}}</v-btn>
                </inertia-link>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-btn v-if="$page.user !== null" icon @click="logout">
                <v-icon>mdi-logout</v-icon>
            </v-btn>
            <inertia-link href="/login">
                <v-btn v-if="$page.user === null" icon>
                    <v-icon>mdi-shield-lock</v-icon>
                </v-btn>
            </inertia-link>
        </v-app-bar>
        <v-main>
            <slot></slot>
        </v-main>
        <v-bottom-navigation fixed v-if="isMobile">
            <v-btn @click="competitions">
                <span>{{$t('calendar')}}</span>
                <v-icon>mdi-calendar-clock</v-icon>
            </v-btn>
            <v-btn @click="form">
                <span>{{$t('reserveRace')}}</span>
                <v-icon>mdi-form-select</v-icon>
            </v-btn>
        </v-bottom-navigation>
    </v-app>
</template>

<script>
export default {
    name: "Layout",
    props: ['settings'],
    data() {
        return {
            menuDrawer: false,
            showMenu: false,
            leagueFilter: null,
        }
    },
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.mobile;
        },
        getMenuText() {
            switch (this.leagueFilter) {
                case null:
                    return this.$t('allCompetitions');
                case 'kielecka':
                    return this.$t('league', {league: 'Kielecka'});
                case 'poznańska':
                    return this.$t('league', {league: 'Poznańska'});
                case 'slaska':
                    return this.$t('league', {league: 'Śląska'});
                case 'pomorska':
                    return this.$t('league', {league: 'Pomorska'});
                case 'pec':
                    return this.$t('league', {league: 'Polish Endurance Cup'});
            }
        }
    },
    provide() {
        return {
            getLeagueFilter: () => this.leagueFilter
        }
    },
    methods: {
        logout: function () {
            this.$inertia.post('/logout')
        },
        competitions() {
            this.$inertia.visit('/');
        },
        form() {
            this.$inertia.visit('/form')
        }
    }
}
</script>

<style scoped>

</style>
